import { Text, Code, FormattedDateTime } from '@customerio/pluma-components/react';
import type { SearchResult } from '@/services/auth/types';
import { MetadataRow } from './metadata-row';

type Props = { result: Extract<SearchResult, { kind: 'snippet' }> };

// Snippets only index title, url, and updated_at (the Liquid value is never indexed), so the
// preview is intentionally minimal: ID and the last-updated timestamp.
export function SnippetPreview({ result }: Props) {
  return (
    <>
      <MetadataRow label="ID">
        <Code size="xs">{result.other.id}</Code>
      </MetadataRow>
      <MetadataRow label="Updated">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={result.other.updated_at} format="medium" />
        </Text>
      </MetadataRow>
    </>
  );
}
